import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../loading.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.html',
  styleUrl: './loading.css',
  host: {
    class: 'block w-full h-full'
  }
})
export class Loading {
  constructor(public loadingService: LoadingService) {}
}
